import React, { createContext, ReactNode, useContext, useMemo } from 'react'

import { LoadingComponent } from '@/components/loading/Loading'
import { TTradeSetting } from '@/data/settings/models'
import { useQueryTradeSetting } from '@/data/settings/queries/trade'

interface SettingContextType {
  tradeSetting: TTradeSetting
}

const SettingContext = createContext<SettingContextType | undefined>(undefined)

export const useApiSettingContext = () => {
  const context = useContext(SettingContext)
  if (context === undefined) {
    throw new Error('useApiSettingContext must be used within an ApiSettingProvider')
  }
  return context
}

interface SettingProviderProps {
  children: ReactNode
}

export const SettingProvider: React.FC<SettingProviderProps> = ({ children }) => {
  const { data: tradeSetting, isLoading } = useQueryTradeSetting()
  const value = useMemo(
    () => ({
      tradeSetting,
    }),
    [tradeSetting]
  ) as SettingContextType

  if (isLoading) {
    return <LoadingComponent />
  }
  return <SettingContext.Provider value={value}>{children}</SettingContext.Provider>
}
